import {Component, inject, output} from '@angular/core';
import {RepoService} from "../../services/repo.service";
import {InAppMessage} from "../../models/inAppMessage";
import {DatePipe} from "@angular/common";
import {MatTab, MatTabGroup} from "@angular/material/tabs";
import {MatMenu, MatMenuItem, MatMenuTrigger} from "@angular/material/menu";
import {MatDrawer} from "@angular/material/sidenav";
import {MatTooltip} from "@angular/material/tooltip";
import {toSignal} from "@angular/core/rxjs-interop";

@Component({
  selector: 'app-history-in-app-messages',
  standalone: true,
  imports: [
    DatePipe,
    MatTabGroup,
    MatTab,
    MatMenu,
    MatMenuTrigger,
    MatMenuItem,
    MatTooltip
  ],
  templateUrl: './favorites-and-history.component.html',
  styleUrl: './favorites-and-history.component.css'
})
export class FavoritesAndHistoryComponent {


  repo = inject(RepoService);
  drawer = inject(MatDrawer);
  copyMessage = output<InAppMessage>();

  historyMessages = toSignal(this.repo.getMessagesHistory(), {initialValue: []});

  favoritesMessages = toSignal(this.repo.getMessagesFavorites(), {initialValue: []});


  addToFavorites(message: InAppMessage) {
    this.repo.addToFavorites(message)
  }

  delete(message: InAppMessage) {
    this.repo.deleteMessageFromFavorites(message)
  }
}
